// LanguageSelection.js
import React, { useEffect, useState } from 'react';
import {
  AIRTABLE_NOT_CONFIGURED,
  getLanguageNames,
  handleSessionError,
} from './Airtable';

const LanguageSelection = ({ elder, onSelectLanguage, onLogout }) => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [canRetry, setCanRetry] = useState(true);
  const [loadAttempt, setLoadAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const fetchLanguages = async () => {
      try {
        setLoading(true);
        setLoadError('');
        setCanRetry(true);
        setLanguages([]);
        if (elder && elder.fields && elder.fields['Language(s) Spoken']) {
          const languageIds = elder.fields['Language(s) Spoken'];
          console.log('Languages Spoken by Elder:', languageIds); // Log the languages
          if (!Array.isArray(languageIds) || languageIds.length === 0) {
            setLanguages([]);
            return;
          }
          const languageNames = await getLanguageNames(languageIds);
          if (cancelled) return;
          console.log('Fetched Language Names:', languageNames); // Log the fetched language names
          setLanguages(languageNames);
        } else {
          console.log('Elder does not have "Languages Spoken" field or it is empty.');
        }
      } catch (error) {
        if (cancelled) return;
        console.error('Error fetching languages:', error);
        if (await handleSessionError(error, onLogout)) return;
        if (error?.code === AIRTABLE_NOT_CONFIGURED) {
          setCanRetry(false);
          setLoadError('Verification data is not configured for this environment.');
        } else {
          setLoadError('Unable to load languages. Please try again.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchLanguages();
    return () => {
      cancelled = true;
    };
  }, [elder, loadAttempt, onLogout]);

  if (loading) {
    return (
      <div className="language-selection-box">
        <p>Loading languages...</p>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="language-selection-box">
        <p className="data-error" role="alert">{loadError}</p>
        {canRetry && <button onClick={() => setLoadAttempt(attempt => attempt + 1)}>Retry</button>}
      </div>
    );
  }

  if (languages.length === 0) {
    return (
      <div className="language-selection-box">
        <p>No languages available.</p>
      </div>
    );
  }

  return (
    <div className="language-selection-box">
      <h2>Select a Language</h2>
      {languages.map(language => (
        <button key={language.id} onClick={() => onSelectLanguage(language.name, language.id, language.uuid)}>
          {language.name}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelection;
